module.exports = __webpack_public_path__ + "assets/img/CMMI3AA.573974c5.png";